export default "__VITE_ASSET__89ddbe72__"